"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Pagination = _interopRequireDefault(require("./Pagination"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _Pagination["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/pagination/index.js
// module id = 289
// module chunks = 0